import { gql } from "@apollo/client";

export const UpdateInstalledBaseNodeSubscription = gql`
    mutation UpdateInstalledBaseNodeSubscription ($id: ID!, $input: InstalledBaseNodeSubscriptionInput!) {
        updateInstalledBaseNodeSubscription(id: $id, input: $input) {
            id
            inApp
            mail
            push
            iotAlert
            iotAlertSeverity
            maintenanceDue
            maintenanceSeverity
            maintenanceType
            installedBaseNode {
                id
                title
            }
        }
    }
`;
